module.exports = "/packs/images/homepage/facilities/gymnastics~9fac77e047c2d2c0b8155c9ab0ed1d7b.jpg";